import {
  ICellEventName,
  ICellRef,
  ISocketEventPayloads
} from "@/store/apis/socketRegistry"

export enum CELL_CONNECT_KIND {
  FIRST = "FIRST",
  AUTOMATIC = "AUTOMATIC",
  REOPEN = "REOPEN",
  REOPEN_AFTER_UNAUTHORIZED = "REOPEN_AFTER_UNAUTHORIZED"
}

export enum CELL_REFUSAL_REASON {
  UNAUTHORIZED = "UNAUTHORIZED",
  UNAVAILABLE = "UNAVAILABLE",
  TRANSPORT = "TRANSPORT"
}

export type IConnectError = Error & { data?: { reason?: unknown } }

export interface IConfirmationDelayInput {
  kind: CELL_CONNECT_KIND
  firstOfConnection: boolean
  msSinceReturn: number | null
  random(): number
}

export interface ICellConfirmation {
  cell: ICellRef | null
  delayMs: number
}

export interface ICellChannelLogEntry {
  receivedAtMs: number
  event: string
  cell: ICellRef | null
  data: unknown
}

export interface ICellChannelState {
  status: "connected" | "reconnecting" | "refused"
  confirmedCell: ICellRef | null
  recentEvents: ICellChannelLogEntry[]
}

export type ICellChannelStateWriter = (
  recipe: (state: ICellChannelState) => ICellChannelState
) => void

export interface ICellsClient {
  start(writeState: ICellChannelStateWriter): void
  stop(): void
  bindCellEvent<K extends ICellEventName>(
    event: K,
    handler: (payload: ISocketEventPayloads[K]) => void
  ): () => void
  onConfirmation(
    listener: (confirmation: ICellConfirmation) => void
  ): () => void
  isStarted(): boolean
}

export interface ICellsClientDeps {
  getAccessToken(): string | null
  refreshTokensIfNeeded(): Promise<boolean>
  subscribeAccessTokenSet(listener: (accessToken: string) => void): () => void
  subscribeAppReturn(listener: () => void): () => void
  nowMs(): number
  random(): number
  schedule(run: () => void, delayMs: number): () => void
}
